import { render, staticRenderFns } from "./wholesaleCalendar.vue?vue&type=template&id=8e3ed584&scoped=true"
import script from "./wholesaleCalendar.vue?vue&type=script&lang=js"
export * from "./wholesaleCalendar.vue?vue&type=script&lang=js"
import style0 from "./wholesaleCalendar.vue?vue&type=style&index=0&id=8e3ed584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3ed584",
  null
  
)

export default component.exports